<template>
  <div class="aads-all" ref="fixed">
    <div class="aads-cntr" ref="cntr" :style="cntrStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {router} from 'eco-env-tool'


export default {
  props: {
    fixedTop: { default: 0 },
    scrollBottom: { default: 0 },
    showActivity: { default: false },
  },
  data: () => ({
    top: 0,
    left: 0,
    width: 0,
    display: "none",
  }),
  computed: {
    cntrStyle() {
      const max = this.getMaxTop() - this.scrollBottom;
      const type = this.top <= 0 ? "top" : this.top >= max ? "bottom" : "fixed";

      switch (type) {
        case "top":
          return {
            position: "relative",
            top: 0,
            display: this.display,
          };

        case "bottom":
          return {
            position: "relative",
            top: max + "px",
            display: this.display,
          };

        case "fixed":
          this.calcLeftandWidth();
          return {
            position: "fixed",
            left: this.left + "px",
            width: this.width + "px",
            top: this.fixedTop + "px",
            display: this.display,
          };

        default:
          return {
            position: "relative",
            top: 0,
            display: this.display,
          };
      }
    },
  },
  methods: {
    openHaveFun() {
     router.open.playground('/')
    },
    openHaveFun3(){
      window.open('/cases/details/WHGongjijin_2', '_blank')
    },
    openActivity() {
      // window.open(
      //   `/community/activity/5c32af46c675c13e2776d813427aca5d`,
      //   "_blank"
      // );
    },
    getMaxTop() {
      if (this.$refs.fixed && this.$refs.cntr)
        return (
          this.$refs.fixed.getBoundingClientRect().height -
          this.$refs.cntr.getBoundingClientRect().height
        );
      else return Infinity;
    },
    calcLeftandWidth() {
      const { left, width } = this.$refs.fixed
        ? this.$refs.fixed.getBoundingClientRect()
        : { left: 0, width: 320 };
      this.width = width;
      this.left = left;
    },
    calc() {
      this.top = this.fixedTop - this.$refs.fixed.getBoundingClientRect().top;
    },
  },
  destroyed() {
    document.removeEventListener("scroll", this.$scrollEvent);
    window.removeEventListener("resize", this.$scrollEvent);
  },
  mounted() {
    this.$scrollEvent = () => {
      this.calc();
      this.calcLeftandWidth();
    };

    this.calc();
    this.calcLeftandWidth();
    this.display = "";
    window.addEventListener("resize", this.$scrollEvent);
    document.addEventListener("scroll", this.$scrollEvent);
  },
};
</script>

<style scoped>
.aads-all {
  height: 100%;
  width: 320px;
}

.aads-content {
  height: 100%;
}
.aads {
  height: 180px;
  width: 320px;
  margin-right: 0;
  margin-left: 0;
  margin-bottom: 20px;
  background-position: center;
  background-size: cover;
}
.havefun {
  cursor: pointer;
  background-image: url(/community/public/assets/experience.svg); 
}
.havefun2 {
  background-image: url(/community/public/assets/havefun2.png);
}
.havefun3 {
  cursor: pointer;
  background-image: url(/community/public/assets/activity2.png);
}
.ads-cntr {
  padding-top: 0;
  padding-right: 0;
  position: relative;
  overflow: hidden;
}
</style>
